import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Calendar, Copy, Check } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function ICalShareDialog({ trigger }) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("group");
  const [groups, setGroups] = useState([]);
  const [coaches, setCoaches] = useState([]);
  const [copied, setCopied] = useState(null);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        const [g, c] = await Promise.all([api.get("/ical/links?kind=group"), api.get("/ical/links?kind=coach")]);
        setGroups(g.data.items || []); setCoaches(c.data.items || []);
      } catch (e) { toast.error("Errore caricamento link"); }
    })();
  }, [open]);

  const backend = process.env.REACT_APP_BACKEND_URL || "";
  const fullUrl = (path) => `${backend}${path}`;

  const copy = async (path, id) => {
    try {
      await navigator.clipboard.writeText(fullUrl(path));
      setCopied(id); setTimeout(() => setCopied(null), 1500);
      toast.success("Link copiato");
    } catch { toast.error("Copia fallita"); }
  };

  const items = tab === "group" ? groups : coaches;

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <div onClick={() => setOpen(true)}>{trigger}</div>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Condividi calendario (iCal)</DialogTitle>
          <DialogDescription>
            Incolla il link in Apple Calendar (File → Nuovo abbonamento) o Google Calendar (Altri calendari → Da URL).
            Il calendario è in sola lettura e si aggiorna automaticamente.
          </DialogDescription>
        </DialogHeader>

        <div className="flex gap-2 mb-3">
          <button data-testid="ical-tab-group" onClick={() => setTab("group")} className={`px-3 py-2 text-sm rounded ${tab === "group" ? "bg-black text-white" : "bg-zinc-100 text-zinc-700"}`}>Gruppi</button>
          <button data-testid="ical-tab-coach" onClick={() => setTab("coach")} className={`px-3 py-2 text-sm rounded ${tab === "coach" ? "bg-black text-white" : "bg-zinc-100 text-zinc-700"}`}>Coach</button>
        </div>

        <div className="max-h-[420px] overflow-y-auto space-y-2">
          {items.length === 0 && <div className="text-sm text-zinc-500 text-center py-6">Nessun elemento</div>}
          {items.map((it) => (
            <div key={it.id} className="flex items-center gap-2 bg-zinc-50 border border-zinc-200 rounded-md p-3">
              <div className="flex-1 min-w-0">
                <div className="font-semibold text-sm">{it.name}</div>
                <div className="text-[11px] font-mono text-zinc-500 truncate">{fullUrl(it.path)}</div>
              </div>
              <Button data-testid={`ical-copy-${it.id}`} size="sm" variant="outline" onClick={() => copy(it.path, it.id)}>
                {copied === it.id ? <Check className="w-3.5 h-3.5 text-emerald-600" /> : <Copy className="w-3.5 h-3.5" />}
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
